import React, { useEffect } from 'react'
import { FormattedMessage } from 'react-intl';
import getLabelByValue from 'sr/helpers/functions/getLabelByValue'
import { businessTypes } from 'sr/i18n/messages/setting'
export const SliderCard = (props) => {

 const handleToggleBusinessType = () => {
    props?.setFilters(prev => {
      const prevTypes = Array.isArray(prev?.business_type) ? prev.business_type : [];

      // compare by id (or whichever unique key you use)
      const exists = prevTypes.some(bt => bt === props?.data.business_type);

      const newTypes = exists
        ? prevTypes.filter(bt => bt !== props?.data.business_type)
        : [...prevTypes, props?.data.business_type];

      return { ...prev, business_type: newTypes };
    });
  };

    return (
                <li onClick={handleToggleBusinessType}
                    className={`my-5 relative order-1 text-start  cursor-pointer px-4 lg:basis-w-mobile basis-w-call matches bg-white rounded-[20px] shadow-sm shadow-slate-300 ${props?.active?.includes(props.data.business_type) ? 'border border-black ' : null} ${props.slidercardstyle && props.slidercardstyle}`}
                >
                    <div className="flex  items-center flex-col py-4">
                        <span className={`${props.textstyle} text-ellipsis w-full text-start`}>
                            {props.data &&  <FormattedMessage id={getLabelByValue(props.data.business_type || 'N/A', businessTypes)}></FormattedMessage>}
                        </span>
                        <span className="w-full mt-2 text-sm lg:text-base flex items-center text-[#0078ae] font-bold">Companies {props.data && props.data.count} <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    className="w-4 h-4"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M8.25 4.5l7.5 7.5-7.5 7.5"
                    />
                </svg></span>
                    </div>
                    {props?.active?.includes(props.data.business_type)  &&
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-5 w-5 absolute top-[5px] right-[10px]">
  <path fillRule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm13.36-1.814a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z" clipRule="evenodd" />
</svg>
}

                </li>
    )
}
